import { useState } from 'react';
import { Link } from 'react-router-dom';
import { manualCategories, manualArticles } from '../../mocks/manuals';
import RelatedLinks from '../../components/feature/RelatedLinks';

export default function ManualPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const filteredArticles = manualArticles.filter(article => {
    const matchesCategory = selectedCategory === 'all' || article.categoryId === selectedCategory;
    const matchesSearch = searchQuery === '' || 
      article.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      article.summary.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50">
      {/* ナビゲーション */}
      <nav className="bg-white/80 backdrop-blur-md border-b border-amber-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center">
                <i className="ri-ship-line text-white text-xl"></i>
              </div>
              <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-teal-600 to-teal-800 bg-clip-text text-transparent">スマイル・ポート</span>
            </Link>
            
            {/* デスクトップメニュー */}
            <div className="hidden md:flex items-center space-x-4">
              <Link to="/" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">ホーム</Link>
              <Link to="/board" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">みんなの休憩室</Link>
              <Link to="/manual" className="text-teal-600 font-medium whitespace-nowrap cursor-pointer">お守りマニュアル</Link>
              <button className="px-4 py-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                ログイン
              </button>
            </div>

            {/* モバイルメニューボタン */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-600 hover:text-teal-600 cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* モバイルメニュー */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-amber-100">
              <div className="flex flex-col space-y-3">
                <Link to="/" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer py-2">ホーム</Link>
                <Link to="/board" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer py-2">みんなの休憩室</Link>
                <Link to="/manual" className="text-teal-600 font-medium cursor-pointer py-2">お守りマニュアル</Link>
                <button className="px-4 py-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer">
                  ログイン
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* ヒーローセクション */}
      <div className="bg-gradient-to-r from-amber-100 via-orange-100 to-rose-100 border-b border-amber-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <i className="ri-book-open-line text-amber-600 text-3xl sm:text-4xl lg:text-5xl"></i>
            </div>
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-3">お守りマニュアル</h1>
            <p className="text-gray-700 text-base sm:text-lg mb-6">
              医療的ケア児を育てる家族のための、実践的な知識とヒント集
            </p>
            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="マニュアルを検索..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 pr-12 border-2 border-amber-300 rounded-full focus:ring-2 focus:ring-amber-500 focus:border-transparent text-sm sm:text-base"
                />
                <i className="ri-search-line absolute right-4 sm:right-5 top-1/2 transform -translate-y-1/2 text-amber-600 text-lg sm:text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        {/* カテゴリフィルター */}
        <div className="bg-white rounded-2xl shadow-sm p-4 sm:p-6 mb-6 sm:mb-8">
          <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4">カテゴリから探す</h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3 sm:gap-4">
            <button
              onClick={() => setSelectedCategory('all')}
              className={`p-3 sm:p-4 rounded-xl border-2 transition-all cursor-pointer ${
                selectedCategory === 'all'
                  ? 'border-teal-500 bg-teal-50'
                  : 'border-gray-200 hover:border-gray-300 bg-white'
              }`}
            >
              <div className="flex items-center space-x-2 sm:space-x-3 mb-2">
                <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-teal-100">
                  <i className="ri-folder-open-line text-teal-600 text-lg sm:text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-800 text-left text-sm sm:text-base">すべて</h3>
              </div>
              <p className="text-xs sm:text-sm text-gray-600 text-left">全記事を表示</p>
            </button>
            {manualCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`p-3 sm:p-4 rounded-xl border-2 transition-all cursor-pointer ${
                  selectedCategory === category.id
                    ? `border-${category.color}-500 bg-${category.color}-50`
                    : 'border-gray-200 hover:border-gray-300 bg-white'
                }`}
              >
                <div className="flex items-center space-x-2 sm:space-x-3 mb-2">
                  <div className={`w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-${category.color}-100`}>
                    <i className={`${category.icon} text-${category.color}-600 text-lg sm:text-xl`}></i>
                  </div>
                  <h3 className="font-bold text-gray-800 text-left text-sm sm:text-base">{category.name}</h3>
                </div>
                <p className="text-xs sm:text-sm text-gray-600 text-left">{category.description}</p>
              </button>
            ))}
          </div>
        </div>

        {/* 記事一覧 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {filteredArticles.length > 0 ? (
            filteredArticles.map((article) => {
              const category = manualCategories.find(c => c.id === article.categoryId);
              return (
                <Link
                  key={article.id}
                  to={`/manual/${article.id}`}
                  className="bg-white rounded-2xl shadow-sm hover:shadow-lg transition-all p-4 sm:p-6 cursor-pointer"
                >
                  <div className="flex items-center space-x-2 mb-3">
                    <div className={`w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full bg-${category?.color}-100`}>
                      <i className={`${category?.icon} text-${category?.color}-600 text-lg sm:text-xl`}></i>
                    </div>
                    <span className={`px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium bg-${category?.color}-100 text-${category?.color}-700`}>
                      {category?.name}
                    </span>
                  </div>

                  <h3 className="text-lg sm:text-xl font-bold text-gray-800 mb-2">{article.title}</h3>
                  <p className="text-gray-600 mb-4 text-sm line-clamp-2">{article.summary}</p>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center space-x-3 sm:space-x-4 text-xs sm:text-sm text-gray-500">
                      <div className="flex items-center space-x-1">
                        <i className="ri-eye-line"></i>
                        <span>{article.views}</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <i className="ri-thumb-up-line"></i>
                        <span>{article.helpful}</span>
                      </div>
                    </div>
                    <div className="text-xs sm:text-sm text-gray-500">
                      {new Date(article.updatedAt).toLocaleDateString('ja-JP')}
                    </div>
                  </div>
                </Link>
              );
            })
          ) : (
            <div className="col-span-full text-center py-12 sm:py-16">
              <i className="ri-file-search-line text-5xl sm:text-6xl text-gray-300 mb-4"></i>
              <p className="text-gray-500 text-base sm:text-lg">該当する記事が見つかりませんでした</p>
              <button
                onClick={() => {
                  setSelectedCategory('all');
                  setSearchQuery('');
                }}
                className="mt-4 px-6 py-3 bg-teal-500 text-white rounded-xl hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
              >
                すべての記事を表示
              </button>
            </div>
          )}
        </div>

        {/* お役立ち情報 */}
        <div className="mt-8 sm:mt-12 bg-gradient-to-br from-purple-100 to-pink-100 rounded-2xl shadow-sm p-6 sm:p-8">
          <div className="text-center mb-6">
            <i className="ri-lightbulb-flash-line text-purple-600 text-3xl sm:text-4xl mb-3"></i>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">探している情報が見つからない？</h2>
            <p className="text-gray-700 text-sm sm:text-base">「みんなの休憩室」で質問してみましょう</p>
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
            <Link
              to="/board"
              className="px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-xl hover:shadow-lg transition-all cursor-pointer whitespace-nowrap text-center"
            >
              掲示板で質問する
            </Link>
            <button className="px-6 py-3 bg-white text-gray-700 rounded-xl hover:shadow-md transition-all cursor-pointer whitespace-nowrap">
              リクエストを送る
            </button>
          </div>
        </div>
      </div>

      {/* 関連リンク */}
      <RelatedLinks />

      {/* フッター */}
      <footer className="bg-gradient-to-r from-teal-700 to-teal-900 text-white mt-0 sm:mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-ship-line text-white text-xl"></i>
                </div>
                <span className="text-lg sm:text-xl font-bold">スマイル・ポート</span>
              </div>
              <p className="text-teal-100 text-sm">医療的ケア児と家族の港</p>
            </div>
            <div>
              <h4 className="font-bold mb-3">リンク</h4>
              <ul className="space-y-2 text-sm text-teal-100">
                <li><Link to="/" className="hover:text-white transition-colors cursor-pointer">ホーム</Link></li>
                <li><Link to="/board" className="hover:text-white transition-colors cursor-pointer">みんなの休憩室</Link></li>
                <li><Link to="/manual" className="hover:text-white transition-colors cursor-pointer">お守りマニュアル</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3">お問い合わせ</h4>
              <p className="text-sm text-teal-100">support@smile-port.jp</p>
            </div>
          </div>
          <div className="border-t border-teal-600 pt-6 sm:pt-8 text-center text-xs sm:text-sm text-teal-100">
            <p>&copy; 2025 スマイル・ポート. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
